import {
  getEducationCategoryFormList,
  getEducationCategoryList,
  pathCreateEducationCategory,
  pathDeleteEducationCategory,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { educationCategoryActions } from "../reducers/educationCategory";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchEducationCategoryList = (id_educationCategory = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationCategoryList(id_educationCategory))
      .then((response) => {
        id_educationCategory == 0
          ? dispatch(
              educationCategoryActions.fetchEducationCategoryList(response.data)
            )
          : dispatch(
              educationCategoryActions.fetchEducationCategoryDetail(
                response.data
              )
            );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducationCategoryFormList = (id_country = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationCategoryFormList(id_country))
      .then((response) => {
        dispatch(
          educationCategoryActions.fetchEducationCategoryFormList(response.data)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchClearEducationCategoryFormList = () => {
  return (dispatch) => {
    dispatch(educationCategoryActions.fetchEducationCategoryFormList([]));
  };
};

export const fetchEducationCategoryAllList = (id_educationCategory = 0) => {
  return (dispatch) => {
    return apiService
      .get(getEducationCategoryList(id_educationCategory))
      .then((response) => {
        dispatch(
          educationCategoryActions.fetchEducationCategoryAllList(response.data)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewEducationCategory = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateEducationCategory(), data)
      .then((response) => {
        toast.success(t("educationCategodyListActions.created"), {
          theme: "colored",
        });
        navigate("/education-category-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditEducationCategory = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateEducationCategory(), data)
      .then((response) => {
        toast.success(t("educationCategodyListActions.updated"), {
          theme: "colored",
        });
        navigate("/education-category-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteEducationCategory = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteEducationCategory(id))
      .then((response) => {
        toast.success(t("educationCategodyListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchEducationCategoryList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
